<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE7FD;</i>
          <span>Manage Site Administrators</span>
        </p>
      </div>

      <!-- Add Edit form -->
      <div class="admManageExamBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a class="searchFormLink" [showUnSavedChangesAlert]="{ form: form, redirect: 'AdmManageSiteAdmin'}">
              Search Site Administrators</a> >
            <span class="addEditFormLink"> {{pageConfig.title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>{{pageConfig.title}}</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Select Business Headquarters" mdInput formControlName="businessCenterId" [mdAutocomplete]="businessCenter" [showDropDown]="{model: 'businessCenter', scope : this }">
                  <md-autocomplete #businessCenter="mdAutocomplete" [displayWith]="_utility.displayFn">
                    <md-option *ngFor="let option of (businessCenterFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf="form.controls.businessCenterId.touched && form.controls.businessCenterId.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Select Location" formControlName="locationId" class="triggerMenuDiv" multiple>
                  <md-option *ngFor="let option of locationOptions" [value]="option" class="subOptionShow">
                    <span>
                      {{ option.name }}
                      <br>
                      <span class="dataDetails">{{ option.locationAddress }}</span>
                    </span>
                  </md-option>
                </md-select>
                <p requiredField *ngIf="form.controls.locationId.touched && form.controls.locationId.invalid"></p>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Red Hat login (external)" maxlength="8" formControlName="rhId" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf="form.controls.rhId.touched && form.controls.rhId.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="First Name" formControlName="firstName" maxlength="100">
                </md-form-field>
              </div>

            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Last Name" formControlName="lastName" maxlength="100">
                </md-form-field>
              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Email" formControlName="email" type="email" maxlength="100">
                </md-form-field>
                <p class="validate" *ngIf="form.controls.email.value && form.controls.email.errors && form.controls.email.errors.pattern">Incorrect Email Format</p>

              </div>
            </div>
            <div class="col s12 m4 l4 ">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Phone" formControlName="contactNo" maxlength="20">
                </md-form-field>
                <p requiredField *ngIf="form.controls.contactNo.touched && form.controls.contactNo.errors && form.controls.contactNo.errors.required"></p>
                <p validatePhoneNumber *ngIf="form.controls.contactNo.touched && form.controls.contactNo.errors && form.controls.contactNo.errors.pattern"></p>
              </div>
            </div>

          </form>
        </md-card-content>

        <md-card-actions>
          <div class="button-row">
            <button [disabled]="form.invalid || pageConfig.isSaveDisable || (form.controls.businessCenterId.value && !form.controls.businessCenterId.value.id)" md-raised-button
              class="glbAdminBtnCls1" (click)="onSave()">
              <img src="./assets/images/saveBtnIcon.png" alt="">SAVE</button>
            <button [disabled]="pageConfig.isEditDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
              <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
            <button [disabled]="pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(false)">RETIRE</button>
            <button [disabled]="this.id == 0 || !pageConfig.isRetireDisable" md-raised-button class="glbAdminBtnCls1" (click)="onChangeStatus(true)">ACTIVATE</button>
          </div>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-site-admin/adm-update-site-admin/adm-update-site-admin.component.html